// wallets.reducer.js

export default (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_ERROR":
      return { ...state, error: action.payload };
    case "GET_WALLET_GROUPS":
      return { ...state, walletGroups: action.payload, error: null };
    case "GET_WALLETS":
      return { ...state, wallets: action.payload, error: null };
    case "ADD_WALLET_GROUP":
      return { ...state, walletGroups: [action.payload,...state.walletGroups] };
    case "EDIT_WALLET_GROUP":
      return {
        ...state,
        walletGroups: state.walletGroups.map((group) =>
          group._id === action.payload._id ? action.payload : group
        ),
      };
    case "DELETE_WALLET_GROUP":
      return {
        ...state,
        walletGroups: state.walletGroups.filter((group) => group._id !== action.payload),
      };
    case "ADD_WALLET":
      return { ...state, wallets: [action.payload,...state.wallets] };
    case "EDIT_WALLET":
      return {
        ...state,
        wallets: state.wallets.map((wallet) =>
          wallet._id === action.payload._id ? action.payload : wallet
        ),
      };
    case "DELETE_WALLET":
      return {
        ...state,
        wallets: state.wallets.filter((wallet) => wallet._id !== action.payload),
      };

    case "SET_MAIN_WALLET":
      return {
        ...state,
        mainWallet: action.payload,
      };
    case "REMOVE_MAIN_WALLET":
      return {
        ...state,
        mainWallet: undefined,
      };
    default:
      return state;
  }
};
